import script from "./TableScreenComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TableScreenComponent.vue?vue&type=script&setup=true&lang=js"

import "./TableScreenComponent.vue?vue&type=style&index=0&id=8c6049c8&scoped=true&lang=scss"

import exportComponent from "D:\\vsts-agent\\_work\\53\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c6049c8"]])

export default __exports__